import { configureStore } from "@reduxjs/toolkit";
import { createMemoryHistory } from "history";
import createRootReducer from "./rootReducer";

export const history = createMemoryHistory();
const rootReducer = createRootReducer(history);

export const store = configureStore({
  reducer: rootReducer,
  devTools: false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
